export default "__VITE_ASSET__2aa65e8c__"